export function getServiceHourCategoryLabel(category, language) {
  if (!category) return ''
  return language === 'es'
    ? category.category_name_es
    : category.category_name_en
}

/**this is future proofing incase we introduce decimals, UI shows whole hours only */
export function formatServiceHourAllocationHoursForDisplay(hours) {
  const n = Number(hours)
  if (!Number.isFinite(n) || n <= 0) return null
  return Math.round(n)
}

export function mapEventServiceHourAllocationsForDisplay(
  allocations,
  language,
) {
  return (allocations || [])
    .map(allocation => {
      const hours = formatServiceHourAllocationHoursForDisplay(
        allocation?.hours,
      )
      if (hours == null || !allocation?.service_hour_category) return null
      return {
        key:
          allocation.id != null
            ? `alloc-${allocation.id}`
            : `cat-${allocation.service_hour_category_id}-${hours}`,
        label: getServiceHourCategoryLabel(
          allocation.service_hour_category,
          language,
        ),
        hours,
      }
    })
    .filter(Boolean)
}

/** Client-side row before save; `clientId` is for React keys until an API `id` exists */
export function createEmptyServiceHourAllocationRow() {
  return {
    clientId: `new-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    service_hour_category_id: null,
    hours: '',
  }
}
